// extracted by mini-css-extract-plugin
module.exports = {"Benefits":"career-benefits-module--Benefits--3bnmP","BenefitsContainer":"career-benefits-module--BenefitsContainer--k4II6"};